"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alignment = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Horizontal_1 = require("./Horizontal");
const Alignment = (props) => {
    return (0, jsx_runtime_1.jsx)(Horizontal_1.HorizontalAlignment, Object.assign({}, props));
};
exports.Alignment = Alignment;
